module.exports = __webpack_public_path__ + "assets/d1279ae7e03e1aff74ec8073cd4c8366.ttf";